import { useContext } from "react";
import { TrackingContext } from "./TrackingProviderContext";

export const useTrackingContext = () => {
  const context = useContext(TrackingContext);
  return context;
};
